module.exports = __webpack_public_path__ + "f48444c6ffade5968c36e663bc81deda.jpg";